import { CustomTable } from "@/components/Tables/CustomTable"
import { columns } from "./Columns"
import { useCustomQuery } from "@/hooks/useCustomQuery"
import AddCustomerReturnsModel from "./Model"
import { useState } from "react"
import { CrudProvider, useCrudContext } from "@/context/crudContext"
import { useAppSelector } from "@/lib/hooks"

export default function CustomerList() {
  const breadcrumbs = [
    { label: "Dashboard", url: "/pos/dashboard" },
    { label: "Footfall" },
  ]
  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-card">
        <h5>Footfall</h5>
      </div>

      <CrudProvider>
        <CustomerReturnsTable />
      </CrudProvider>
    </>
  )
}

function CustomerReturnsTable() {
  const canImport = useAppSelector((state) =>
    state.auth.user?.permissions?.includes("operations-imports-create")
  )
  const [currentPage, setCurrentPage] = useState(1)
  const [searchQuery, setSearchQuery] = useState("")
  const {
    data: response,
    isLoading,
    isFetching,
  } = useCustomQuery(
    ["customer-returns", currentPage, searchQuery], // These are your query keys
    `customer-returns?page=${currentPage}${searchQuery ? `&search=${searchQuery}` : ""}` // Explicitly include page in URL
  )

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage)
  }
  const { openDialog } = useCrudContext()

  return (
    <>
      <CustomTable
        label="Footfall"
        columns={columns}
        data={response?.data?.data}
        meta={response?.data?.meta}
        onPageChange={handlePageChange}
        view={false}
        isLoading={isLoading}
        apiPath="customer-returns"
        showImport={canImport}
      />

      {openDialog ? <AddCustomerReturnsModel /> : null}
    </>
  )
}
